export default function selectTwo() { 
    $(document).ready(function() {
        $('.js-example-basic-multiple').select2();
    });
}
 